<template>
  <Menu v-if="$route.meta.sidebar !== 'main'" as="div" class="relative mt-4 w-full">
    <MenuButton
      class="pl-4 trans-150 w-full rounded-lg border border-gray-700 bg-gray-600/1 py-2 pr-2"
    >
      <div class="flex items-center justify-between"></div>

      <div class="flex items-center justify-between">
        <div class="truncate whitespace-nowrap text-sm tracking-wide text-gray-400">mydemo.com</div>
        <ChevronDownIcon class="h-5 w-5 shrink-0 text-blue-300/40" />
      </div>
    </MenuButton>

    <transition
      enter-active-class="transition duration-75 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition duration-150 ease-out"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <MenuItems
        class="absolute z-50 mt-2 w-full overflow-hidden rounded-lg bg-white pt-1 shadow-xl"
        as="div"
      >
        <MenuItem
          class="text-sky-600 flex w-full items-center justify-between px-4 py-2"
          as="a"
          hfref="/website/experiments/"
        >
          <div class="font-medium truncate whitespace-nowrap text-sm">mydemo.com</div>
          <CheckIcon class="h-4 w-4 shrink-0 stroke-2" />
        </MenuItem>

        <router-link
          class="group flex w-full items-center border-t border-gray-200/100 px-3 py-3 hover:bg-gray-100"
          to="/websites/"
        >
          <RectangleStackIcon
            class="mr-2.5 h-5 w-5 shrink-0 text-gray-500 group-hover:text-gray-600"
          />
          <div
            class="whitespace-nowrap text-[11px] font-medium uppercase tracking-wider text-gray-500 group-hover:text-gray-700"
          >
            Websites list
          </div>
        </router-link>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { CheckIcon } from '@heroicons/vue/24/outline'

import {
    ChevronDownIcon,
    GlobeAltIcon,
    RectangleStackIcon
} from '@heroicons/vue/24/solid'

export default defineComponent({
    components: {
        Menu,
        MenuButton,
        ChevronDownIcon,
        MenuItems,
        MenuItem,
        GlobeAltIcon,
        RectangleStackIcon,
        CheckIcon
    },
    props: {},

    setup() {
        return {}
    }

})
</script>
